import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemText } from '../../material-ui/List';
import { NotificationItem } from './NotificationItem/NotificationItem';

const getText = (selectedIndex) => {
    if (selectedIndex === 0) {
        return 'messages.noDocuments';
    }

    if (selectedIndex === 1) {
        return 'messages.noAcLimitations';
    }

    return 'messages.noLibraryItems';
};

export const NotificationItems = memo(({ items = [], selectedIndex }) => {
    const { t: translate } = useTranslation();

    return items.length > 0 ? (
        items.map((item) => <NotificationItem key={item.id} {...item} selectedIndex={selectedIndex} />)
    ) : (
        <ListItem key={0} button={true} disabled={true}>
            <ListItemText primary={translate(getText(selectedIndex))} />
        </ListItem>
    );
});
